<template>
  <div>
    <Mapa v-if="mapaStyleLeaflet"></Mapa>
    <GoogleMaps v-if="mapaStyleMaps"/>
  </div>   
</template>

<script lang="ts">
import store from './store';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {Inmueble} from './Modelos/Inmueble';
import {ConfiguracionExterna} from './Modelos/ConfiguracionExterna';
import Mapa from './components/Mapa.vue';
import GoogleMaps from "./components/Mapas/Google/Mapa/GoogleMaps.vue";
import {namespace} from 'vuex-class';
const WidgetMapStore = namespace('WidgetMapStore');

@Component({
  store:store,
  components: {
    Mapa,
    GoogleMaps
  },
})
export default class App extends Vue {

  @Prop({default:() => ({})})
  inmuebles!:Array<Inmueble>;

  @Prop()
  configuracion!:ConfiguracionExterna
  
  @WidgetMapStore.State('configuracionExterna')
  configuracionExterna!:ConfiguracionExterna;

  constructor()
  {
    super();
    
  }

  @WidgetMapStore.Action
  updateInmuebles!:(inmuebles:Array<Inmueble>) => void;
  
  @WidgetMapStore.Action
  updateConfiguracionExterna!:(config:ConfiguracionExterna) => void;
 

  @Watch('inmuebles')
  onInmueblesChange(newValue:Array<Inmueble>):void
  {  
    if(Array.isArray(newValue)){
      this.updateInmuebles(this.inmuebles);
    }else{
      console.log("El valor que esta asignando a los inmuebles es invalido", newValue);
    }
  }

  @Watch('configuracion')
  onConfiguracionChange(newConfig:ConfiguracionExterna):void
  {  
    if(newConfig){
      this.updateConfiguracionExterna(this.configuracion);
    }
  }
  mounted() : void
  {
    if(this.inmuebles && this.inmuebles.length > 0) {    
      this.updateInmuebles(this.inmuebles);
    }
    
    if(this.configuracion){
      this.updateConfiguracionExterna(this.configuracion);
    }

      this.$store.dispatch("AnalyticsStore/logEvent",{
              name:'screen_view',
              data: {
                screen_name:'Mapa Inmu'
              }
      });

  }

  /**
   * Para saber el estado esperado
   * @param styleEsperado
   */
  get mapaStyleLeaflet(): boolean
  {   
    return this.configuracionExterna?.theme?.mapa === 'leaflet';
  }

get mapaStyleMaps(): boolean
  {   
    return this.configuracionExterna?.theme?.mapa === 'maps';
  }
  

}
</script>

<style lang="scss">

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;  
}
.leaflet-popup-content{
  margin: 0 !important;
}

</style>
